// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const toolbarHeight = 75;
export const appDrawerWidth = 320;
export const maxFriendsLimit = 10;
export const thisElection = 47009;
